
// 设置路由规则
export const routes = [
    {
        path:'/',
        component:()=>import('../views/message/index.vue')
    },{
        path:'/message',
        component:()=>import('../views/message/index.vue')
    },{
		path:'/message/chat',
        component:()=>import('../views/message/chat.vue')
    },{
	    path:'/cash',
	    component:()=>import('../views/cash.vue')
	},{
        // 定义404路由
        path:'/404',
        component:()=>import('../views/404.vue')
    },{
        // 匹配为定义路由然后重定向到404页面
        path:'/:pathMath(.*)',
        redirect:'/404'
    }
];


 